export const maritalStatus = [
  {
    value: "soltero",
    label: "Soltero",
  },
  {
    value: "casado",
    label: "Casado",
  },
  {
    value: "union",
    label: "Unión libre",
  },
  {
    value: "viudo",
    label: "Viudo",
  },
];
